import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, Outlet } from 'react-router-dom';

function ProtectedAdminRoute() {
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !user.is_admin) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  // Don't render anything until we know the user status
  if (!user) {
    return null;
  }

  // Only render nested routes if user is admin
  return user.is_admin ? <Outlet /> : null;
}

export default ProtectedAdminRoute;
